/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ level: NonNullable<unknown> }} Today_Checkin_AskInputs */

const en_us2_today_checkin_ask = /** @type {(inputs: Today_Checkin_AskInputs) => LocalizedString} */ (i) => {
	if (i?.level === "moderate") return /** @type {LocalizedString} */ (`My muscles are moderately sore. What about today's workout?`);
	return /** @type {LocalizedString} */ (`My muscles are very sore. What about today's workout?`)
	
};

const pt_br2_today_checkin_ask = /** @type {(inputs: Today_Checkin_AskInputs) => LocalizedString} */ (i) => {
	if (i?.level === "moderate") return /** @type {LocalizedString} */ (`Estou com dor muscular moderada. Como fica o treino de hoje?`);
	return /** @type {LocalizedString} */ (`Estou com dor muscular intensa. Como fica o treino de hoje?`)
	
};

const es_419_today_checkin_ask = /** @type {(inputs: Today_Checkin_AskInputs) => LocalizedString} */ (i) => {
	if (i?.level === "moderate") return /** @type {LocalizedString} */ (`Tengo dolor muscular moderado. ¿Qué hago con el entrenamiento de hoy?`);
	return /** @type {LocalizedString} */ (`Tengo dolor muscular intenso. ¿Qué hago con el entrenamiento de hoy?`)
	
};

const pt_pt2_today_checkin_ask = /** @type {(inputs: Today_Checkin_AskInputs) => LocalizedString} */ (i) => {
	if (i?.level === "moderate") return /** @type {LocalizedString} */ (`Tenho dor muscular moderada. Como fica o treino de hoje?`);
	return /** @type {LocalizedString} */ (`Tenho dor muscular intensa. Como fica o treino de hoje?`)
	
};

const fr_fr2_today_checkin_ask = /** @type {(inputs: Today_Checkin_AskInputs) => LocalizedString} */ (i) => {
	if (i?.level === "moderate") return /** @type {LocalizedString} */ (`J'ai des courbatures modérées. Que faire pour la séance d'aujourd'hui ?`);
	return /** @type {LocalizedString} */ (`J'ai de fortes courbatures. Que faire pour la séance d'aujourd'hui ?`)
	
};

const de_de2_today_checkin_ask = /** @type {(inputs: Today_Checkin_AskInputs) => LocalizedString} */ (i) => {
	if (i?.level === "moderate") return /** @type {LocalizedString} */ (`Ich habe mittleren Muskelkater. Was heißt das für das heutige Training?`);
	return /** @type {LocalizedString} */ (`Ich habe starken Muskelkater. Was heißt das für das heutige Training?`)
	
};

const it_it2_today_checkin_ask = /** @type {(inputs: Today_Checkin_AskInputs) => LocalizedString} */ (i) => {
	if (i?.level === "moderate") return /** @type {LocalizedString} */ (`Ho un indolenzimento muscolare moderato. Come faccio con l'allenamento di oggi?`);
	return /** @type {LocalizedString} */ (`Ho un forte indolenzimento muscolare. Come faccio con l'allenamento di oggi?`)
	
};

/**
* | level | output |
* | --- | --- |
* | "moderate" | "My muscles are moderately sore. What about today's workout?" |
* | * | "My muscles are very sore. What about today's workout?" |
*
* @param {Today_Checkin_AskInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_checkin_ask = /** @type {((inputs: Today_Checkin_AskInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Checkin_AskInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_checkin_ask(inputs)
	if (locale === "es-419") return es_419_today_checkin_ask(inputs)
	if (locale === "pt-PT") return pt_pt2_today_checkin_ask(inputs)
	if (locale === "fr-FR") return fr_fr2_today_checkin_ask(inputs)
	if (locale === "de-DE") return de_de2_today_checkin_ask(inputs)
	if (locale === "it-IT") return it_it2_today_checkin_ask(inputs)
	return en_us2_today_checkin_ask(inputs)
});
export { today_checkin_ask as "today.checkin_ask" }